import { Component } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: 'checkbox-cell',
    templateUrl: 'g-checkbox-renderer.component.html'
})
export class AGCheckBoxRendererComponent implements ICellRendererAngularComp {
    private params: any;
    public value: number;

    agInit(params: any): void {
        this.params = params;
        this.value = this.params.value;
    }

    refresh(params: any): boolean {
        this.params = params;
        this.value = params.value;
        return true;
    }
}